/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Fail_Delivery_DescInputs */

const vi_order_fail_delivery_desc = /** @type {(inputs: Order_Fail_Delivery_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập lý do giao thất bại (tối thiểu 3 ký tự)`)
};

/**

* @param {Order_Fail_Delivery_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_fail_delivery_desc = /** @type {((inputs?: Order_Fail_Delivery_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Fail_Delivery_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_fail_delivery_desc(inputs)
});